module.exports = __webpack_public_path__ + "img/EXTERIOR-VITARA-1.c76c7eb7.jpg";